import { selectNodeContents } from 'services/utils';

/* @ngInject */
export default class ClipboardService {
    constructor(ToastService) {
        this.ToastService = ToastService;
    }

    copyStringToClipboard(text, label) {
        let copied; 

        try {
            copied = navigator.clipboard.writeText(text);
        } catch (e) {
            copied = false
        }

        if (copied) {
            this.ToastService.showSimpleTranslated('copy_to_clipboard_was_successful', {}, {
                label
            });
        } else {
            this.ToastService.showSimpleTranslated('copy_to_clipboard_wasnt_successful');
        }
    }

    copyToClipboard(node, label) {
        selectNodeContents(node);

        let copied;

        try {
            copied = document.execCommand('copy');
        } catch (e) {
            copied = false;
        }

        if (copied) {
            this.ToastService.showSimpleTranslated('copy_to_clipboard_was_successful', {}, {
                label
            });
        } else {
            this.ToastService.showSimpleTranslated('copy_to_clipboard_wasnt_successful');
        }
    }
}
